import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { FeatLayerControlComponent, LayerControlInputData } from '../feat-layer-control/feat-layer-control.component';
import { CommonModalService } from 'app/services/common-modal.service';
import { Subscription } from 'rxjs';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { LayerService } from 'app/services/layer.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { FeatMapBookmarkManagerComponent } from '../feat-map-bookmark-manager/feat-map-bookmark-manager.component';

@Component({
  selector: 'app-feat-map-controls',
  templateUrl: './feat-map-controls.component.html',
  styleUrls: ['./feat-map-controls.component.css']
})
export class FeatMapControlsComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() mapType: 'data' | 'report' = 'data';
	
	map: LRSMap.Map;

	// For report map use
	showRefLayerOpacitySlider: boolean;
	refLayerOpacity: number;
	showBasemapOpacitySlider = true;
	basemapOpacity: number;
	
	showZoomToRecord = false;

	private mapLegendTimeout;

	private mapSub: Subscription;
	private selectedLayerSub: Subscription;
	private selectedRecordSub: Subscription;
	private currentCardSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private floatPopupService: FloatPopupService,
		private layerService: LayerService,
		private mapControlsService: MapControlsService,
		private mapSharedService: MapSharedService,
		private mapLayerService: MainDataMapLayersService,
		private mapService: MainDataMapService,
		private iMapService: InterlayerMapService,
		// private modalService: CommonModalService,
		private reportService: InterlayerReportService
	) { }
	zoomToRecord() {
		if (!this.showZoomToRecord) {
			return;
		}
		this.mapControlsService.zoomToRecordSubject.next();
	}
	zoomIn() {
		const map = this.map;
		map.olMap.getView().setZoom(map.olMap.getView().getZoom() + 1);
	}
	zoomOut() {
		const map = this.map;
		const zoomLevel = map.olMap.getView().getZoom();
		if (zoomLevel > this.mapSharedService.minZoomLevel) {
			map.olMap.getView().setZoom(zoomLevel - 1);
		}
	}
	async toggleLayerControl() {
			// this.mapService.layerControlToggle.next();
		let dataLayerCateCode, refLayerCateCode, refReportLayerCateCode;
		if (this.mapType === 'data') {
			const layer = this.activityService.selectedLayerBS.getValue();
			dataLayerCateCode = layer ? layer.layer.category.code : null;
		} else {
			const report = this.reportService.selectedReportBS.getValue();
			dataLayerCateCode = report ? report.subjectLayerCate : null;
			refLayerCateCode = report ? report.refLayerCate : null;
			// TODO refReportLayerCateCode
		}
		const data: LayerControlInputData = {
			mapType: this.mapType,
			dataLayerCateCode: dataLayerCateCode,
			refLayerCateCode: refLayerCateCode,
			refReportLayerCateCode: refReportLayerCateCode
		}
		const options = {
			data: data
		};
		this.floatPopupService.openPopup(FeatLayerControlComponent, data, ['layer-control-popup']);
	}
	openBookmark() {
		this.floatPopupService.openPopup(FeatMapBookmarkManagerComponent, null, ['map-bookmark-popup']);
	}

	onRefSliderDragEnd() {
		const layer = this.iMapService.map.addedLayers[this.iMapService.secondDataLayerName];
		this.mapSharedService.updateLayerOpacity(layer, this.refLayerOpacity);
	}
	onBasemapSliderDragEnd() {
		const map = this.map;
		this.mapSharedService.updateLayerOpacity(map.baseMapLayerGroup, this.basemapOpacity);
	}

	onMouseoverMapLegend() {
		if (this.mapLegendTimeout) {
			clearTimeout(this.mapLegendTimeout);
		}
		this.mapLegendTimeout = setTimeout(() => {
			this.mapService.mapLegendBS.next({
				show: true
			});
			this.mapLegendTimeout = null;
		}, 200);
	}
	onMouseoutMapLegend() {
		if (this.mapLegendTimeout) {
			clearTimeout(this.mapLegendTimeout);
		}
		this.mapLegendTimeout = setTimeout(() => {
			this.mapService.mapLegendBS.next({
				show: false
			})
			this.mapLegendTimeout = null;
		}, 1500);
	}

	private setDataMapConfigs() {
		this.mapSub = this.mapService.mapBS.subscribe(data => this.map = data);
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(l => {
			const map = this.map;
			if (!map) {
				return;
			}
			// this.setBdryLayers();
		});
		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			if (data && data.id) {
				this.showZoomToRecord = true;
			} else {
				this.showZoomToRecord = false;
			}
		});
	}
	private setReportMapConfigs() {
		this.refLayerOpacity = this.iMapService.initRefLayerOpacity;

		this.mapSub = this.mapService.mapBS.subscribe(data => this.map = data);

		this.selectedRecordSub = this.reportService.selectedReportRecordsBS.subscribe(data => {
			if (data && data.rec) {
				this.showZoomToRecord = true;
			} else {
				this.showZoomToRecord = false;
			}
		});
	}
	ngOnInit() {
		this.showRefLayerOpacitySlider = this.mapType === 'report';
		this.basemapOpacity = this.mapSharedService.initBasemapOpacity;
	}
	ngAfterViewInit(): void {
		switch (this.mapType) {
			case 'data':  this.setDataMapConfigs(); break;
			case 'report': this.setReportMapConfigs(); break;
		}
	}
	ngOnDestroy(): void {
		this.mapSub.unsubscribe();
		if (this.mapType === 'data') {
			this.currentCardSub.unsubscribe();
			this.selectedLayerSub.unsubscribe();
		} else if (this.mapType === 'report') {
			this.selectedRecordSub.unsubscribe();
		}
	}
}
